import {RRule} from 'rrule';

import type {ControlOption} from 'shells/card/segmented-control';

import type {CycleUnit} from './task-custom-recurrence-popover';

export const DAY_UNIT = 'day';
export const WEEK_UNIT = 'week';
export const MONTH_UNIT = 'month';

export const FREQUENCY_SEGMENT_OPTIONS: ControlOption<CycleUnit>[] = [
    {value: DAY_UNIT, title: 'Daily', type: 'small'},
    {value: WEEK_UNIT, title: 'Weekly', type: 'small'},
    {value: MONTH_UNIT, title: 'Monthly', type: 'small'},
];

export const SINGULAR_CYCLE_UNIT_OPTIONS = [
    {label: 'week', value: WEEK_UNIT},
    {label: 'month', value: MONTH_UNIT},
];
export const PLURAL_CYCLE_UNIT_OPTIONS = [
    {label: 'weeks', value: WEEK_UNIT},
    {label: 'months', value: MONTH_UNIT},
];

export const OCCURRENCE_OPTIONS = [
    {label: '1st', value: 1},
    {label: '2nd', value: 2},
    {label: '3rd', value: 3},
    {label: '4th', value: 4},
    {label: 'last', value: -1},
];

export const WEEKDAY_OPTIONS = [
    {label: 'Sunday', value: RRule.SU.weekday},
    {label: 'Monday', value: RRule.MO.weekday},
    {label: 'Tuesday', value: RRule.TU.weekday},
    {label: 'Wednesday', value: RRule.WE.weekday},
    {label: 'Thursday', value: RRule.TH.weekday},
    {label: 'Friday', value: RRule.FR.weekday},
    {label: 'Saturday', value: RRule.SA.weekday},
];

export const RRULE_WEEKDAYS = [
    RRule.MO,
    RRule.TU,
    RRule.WE,
    RRule.TH,
    RRule.FR,
    RRule.SA,
    RRule.SU,
] as const;
